import { render } from "./NewMainMenu.vue?vue&type=template&id=3f809e1a"
import script from "./NewMainMenu.vue?vue&type=script&lang=js"
export * from "./NewMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__